import logoUrl from '../assets/logo.png';

/**
 * The CyberCub brand mark.
 *
 * The artwork is a raster, so this is an <img> rather than the drawn
 * shield it replaced. It is imported rather than pointed at by path so
 * the build fingerprints the filename: the mark has already been recut
 * once, and a browser holding the old one under the same name has no
 * way of knowing. 256px, comfortably more than the largest place it
 * appears (54 CSS px, so 162 physical pixels on a three-times
 * display).
 *
 * The source file in the repo root is 16:9 with the badge floating in
 * a large black field. What is served has been cropped to the badge and
 * had that surrounding black replaced with transparency, so the mark
 * sits on the cream page and the dark one without carrying a black
 * rectangle around with it.
 *
 *   <CyberCubLogo size={40} />            mark only
 *   <CyberCubLogo size={40} withText />   mark + wordmark
 */
export default function CyberCubLogo({
  size = 40,
  withText = false,
  className = '',
  title = 'CyberCub',
}) {
  const mark = (
    <img
      src={logoUrl}
      /* The navbar lockup sizes this in CSS, against the wordmark it
         sits beside - see .brand in app.css. These stay as the
         intrinsic size so the row does not jump while it loads. */
      width={size}
      height={size}
      className="logo-mark"
      /* Decorative when the wordmark beside it already says the name,
         so a screen reader is not told "CyberCub" twice. */
      alt={withText ? '' : title}
      aria-hidden={withText ? 'true' : undefined}
      /* Every page has one in the header: it is wanted immediately, and
         a logo that fades in after the rest looks broken. */
      loading="eager"
      decoding="async"
      draggable="false"
    />
  );

  if (!withText) return <span className={`logo ${className}`}>{mark}</span>;

  return (
    <span className={`logo logo-lockup ${className}`} role="img" aria-label={title}>
      {mark}
      <span className="logo-word" aria-hidden="true">
        Cyber<span className="logo-word-alt">Cub</span>
      </span>
    </span>
  );
}
